/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiError,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    WorkspaceMembersInviteRequest,
    WorkspaceMembersInviteRequestFromJSON,
    WorkspaceMembersInviteRequestToJSON,
    WorkspaceMembersInviteResponse,
    WorkspaceMembersInviteResponseFromJSON,
    WorkspaceMembersInviteResponseToJSON,
    WorkspaceMembersResendResponse,
    WorkspaceMembersResendResponseFromJSON,
    WorkspaceMembersResendResponseToJSON,
    WorkspaceMembersResponse,
    WorkspaceMembersResponseFromJSON,
    WorkspaceMembersResponseToJSON,
} from '../models';

export interface GetWorkspaceMembersRequest {
    organizationId: string;
    workspaceId: string;
    limit?: number;
    nextPageToken?: string;
    previousPageToken?: string;
}

export interface InviteWorkspaceMembersRequest {
    organizationId: string;
    workspaceId: string;
    workspaceMembersInviteRequest?: WorkspaceMembersInviteRequest;
}

export interface RemoveWorkspaceMemberRequest {
    organizationId: string;
    workspaceId: string;
    workspaceMemberId: string;
}

export interface ResendInvitationToWorkspaceMemberRequest {
    organizationId: string;
    workspaceId: string;
    workspaceMemberId: string;
}

export interface ResendInvitationToWorkspaceMembersRequest {
    organizationId: string;
    workspaceId: string;
}

/**
 * 
 */
export class WorkspaceMembersApi extends runtime.BaseAPI {

    /**
     * Get list of members of the workspace.
     */
    async getWorkspaceMembersRaw(requestParameters: GetWorkspaceMembersRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<WorkspaceMembersResponse>> {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId','Required parameter requestParameters.organizationId was null or undefined when calling getWorkspaceMembers.');
        }

        if (requestParameters.workspaceId === null || requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId','Required parameter requestParameters.workspaceId was null or undefined when calling getWorkspaceMembers.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.nextPageToken !== undefined) {
            queryParameters['nextPageToken'] = requestParameters.nextPageToken;
        }

        if (requestParameters.previousPageToken !== undefined) {
            queryParameters['previousPageToken'] = requestParameters.previousPageToken;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organization/{organizationId}/workspaces/{workspaceId}/workspace-members`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters.workspaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceMembersResponseFromJSON(jsonValue));
    }

    /**
     * Get list of members of the workspace.
     */
    async getWorkspaceMembers(requestParameters: GetWorkspaceMembersRequest, initOverrides?: RequestInit): Promise<WorkspaceMembersResponse> {
        const response = await this.getWorkspaceMembersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Invite one or more members to the workspace.
     */
    async inviteWorkspaceMembersRaw(requestParameters: InviteWorkspaceMembersRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<WorkspaceMembersInviteResponse>> {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId','Required parameter requestParameters.organizationId was null or undefined when calling inviteWorkspaceMembers.');
        }

        if (requestParameters.workspaceId === null || requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId','Required parameter requestParameters.workspaceId was null or undefined when calling inviteWorkspaceMembers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organization/{organizationId}/workspaces/{workspaceId}/workspace-members`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters.workspaceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WorkspaceMembersInviteRequestToJSON(requestParameters.workspaceMembersInviteRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceMembersInviteResponseFromJSON(jsonValue));
    }

    /**
     * Invite one or more members to the workspace.
     */
    async inviteWorkspaceMembers(requestParameters: InviteWorkspaceMembersRequest, initOverrides?: RequestInit): Promise<WorkspaceMembersInviteResponse> {
        const response = await this.inviteWorkspaceMembersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a workspace member.
     */
    async removeWorkspaceMemberRaw(requestParameters: RemoveWorkspaceMemberRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId','Required parameter requestParameters.organizationId was null or undefined when calling removeWorkspaceMember.');
        }

        if (requestParameters.workspaceId === null || requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId','Required parameter requestParameters.workspaceId was null or undefined when calling removeWorkspaceMember.');
        }

        if (requestParameters.workspaceMemberId === null || requestParameters.workspaceMemberId === undefined) {
            throw new runtime.RequiredError('workspaceMemberId','Required parameter requestParameters.workspaceMemberId was null or undefined when calling removeWorkspaceMember.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organization/{organizationId}/workspaces/{workspaceId}/workspace-members/{workspaceMemberId}`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters.workspaceId))).replace(`{${"workspaceMemberId"}}`, encodeURIComponent(String(requestParameters.workspaceMemberId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a workspace member.
     */
    async removeWorkspaceMember(requestParameters: RemoveWorkspaceMemberRequest, initOverrides?: RequestInit): Promise<void> {
        await this.removeWorkspaceMemberRaw(requestParameters, initOverrides);
    }

    /**
     * Resend the invitation to the specified workspace member. By default, this will resend invitations to members in a pending state.
     */
    async resendInvitationToWorkspaceMemberRaw(requestParameters: ResendInvitationToWorkspaceMemberRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId','Required parameter requestParameters.organizationId was null or undefined when calling resendInvitationToWorkspaceMember.');
        }

        if (requestParameters.workspaceId === null || requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId','Required parameter requestParameters.workspaceId was null or undefined when calling resendInvitationToWorkspaceMember.');
        }

        if (requestParameters.workspaceMemberId === null || requestParameters.workspaceMemberId === undefined) {
            throw new runtime.RequiredError('workspaceMemberId','Required parameter requestParameters.workspaceMemberId was null or undefined when calling resendInvitationToWorkspaceMember.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organization/{organizationId}/workspaces/{workspaceId}/workspace-members/{workspaceMemberId}/resend`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters.workspaceId))).replace(`{${"workspaceMemberId"}}`, encodeURIComponent(String(requestParameters.workspaceMemberId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Resend the invitation to the specified workspace member. By default, this will resend invitations to members in a pending state.
     */
    async resendInvitationToWorkspaceMember(requestParameters: ResendInvitationToWorkspaceMemberRequest, initOverrides?: RequestInit): Promise<void> {
        await this.resendInvitationToWorkspaceMemberRaw(requestParameters, initOverrides);
    }

    /**
     * Resend invitations to the members of a workspace. By default, this will resend invitations to members in a pending state. This request can be updated to take a request body that is a list of specified states that a workspace member must be in to be resent an invitation.
     * Resend invitations to the members of a workspace. By default, this will resend invitations to members in a pending state.
     */
    async resendInvitationToWorkspaceMembersRaw(requestParameters: ResendInvitationToWorkspaceMembersRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<WorkspaceMembersResendResponse>> {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId','Required parameter requestParameters.organizationId was null or undefined when calling resendInvitationToWorkspaceMembers.');
        }

        if (requestParameters.workspaceId === null || requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId','Required parameter requestParameters.workspaceId was null or undefined when calling resendInvitationToWorkspaceMembers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organization/{organizationId}/workspaces/{workspaceId}/workspace-members/resend`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters.workspaceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceMembersResendResponseFromJSON(jsonValue));
    }

    /**
     * Resend invitations to the members of a workspace. By default, this will resend invitations to members in a pending state. This request can be updated to take a request body that is a list of specified states that a workspace member must be in to be resent an invitation.
     * Resend invitations to the members of a workspace. By default, this will resend invitations to members in a pending state.
     */
    async resendInvitationToWorkspaceMembers(requestParameters: ResendInvitationToWorkspaceMembersRequest, initOverrides?: RequestInit): Promise<WorkspaceMembersResendResponse> {
        const response = await this.resendInvitationToWorkspaceMembersRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
